module.exports = __webpack_public_path__ + "img/logo-maps.4c2c75fe.webp";